import React from 'react';

import SearchTeaser from '../../../components/SearchTeaser';
import NodePersonDetail from './Detail';

const NodePerson = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'search_teaser':
      return <SearchTeaser entity={entity} />;
    case 'full':
    default:
      return <NodePersonDetail entity={entity} />;
  }
};

export default NodePerson;
